import React, { useState } from 'react';
import {
  TextField,
  Typography,
  Button,
  Alert,
  AlertTitle,
  IconButton,
  Collapse,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';
import './resetPassword.scss';

import { COLOR_PRIMARY, COLOR_PRIMARY_DARK, COLOR_PRIMARY_LIGHT } from 'src/const';

import { callApi } from '../../core/callApi';
import { getTokenThunk } from '../../store/Auth/actions';

const ResetPassword = () => {
  const [email, setEmail] = useState<string>('');
  const [isEmailValid, setIsEmailValid] = useState<boolean>(true);
  const [passwordReseted, setPasswordReseted] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const isLoggedIn = getTokenThunk()();

  const validateEmail = (email): boolean => {
    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
      return true;
    } else return false;
  };

  const handlePasswordResetClick = async () => {
    if (passwordReseted) return null;

    let origin = '';
    const currentDomain = window.location.href.split('//')[1].split('/')[0];
    if (currentDomain === 'localhost:3000') {
      origin = 'localhost';
    } else if (currentDomain === 'app.airbtics.staging.s3-website.us-east-2.amazonaws.com') {
      origin = 'staging';
    }

    console.log('Mode: ', origin);

    if (email.trim() === '') {
      setAlertMessage('Email is missing!');
      return null;
    }
    if (!validateEmail(email)) {
      setAlertMessage('Email is not valid !');
      return null;
    }

    setLoading(true);

    const url = 'https://bwb70jlw69.execute-api.us-east-2.amazonaws.com/default/resetPassword';
    const config = {
      body: [
        {
          email: email.trim(),
          origin: origin,
        },
      ],
      method: 'post',
    };

    try {
      const response = await callApi(url, config, false);
      if (response && response.success) {
        setLoading(false);
        setPasswordReseted(true);
        setAlertMessage('');
      } else if (response && response.error) {
        setLoading(false);
        setAlertMessage(response.error);
      } else {
        setLoading(false);
        setAlertMessage('');
      }
    } catch (err) {
      setLoading(false);
      if (err instanceof Error) {
        setAlertMessage(err.message);
      }
    }

    return null;
  };

  // if (isLoggedIn) {
  //   return (
  //     <div
  //       style={{
  //         position: 'absolute',
  //         top: '50%',
  //         left: '50%',
  //         transform: 'translate(-50%, -50%)',
  //         textAlign: 'center',
  //         color: '#555',
  //       }}
  //     >
  //       <Typography variant="h1" component="h5">
  //         4<span style={{ color: COLOR_PRIMARY_DARK }}>0</span>4
  //       </Typography>
  //       <Typography
  //         variant="h6"
  //         gutterBottom
  //         component="h2"
  //         sx={{
  //           textAlign: 'center',
  //           marginBottom: passwordReseted ? 0 : 4,
  //           color: 'rgb(50,56,63)',
  //         }}
  //       >
  //         You are currently logged in, please go back to the{' '}
  //         <Link to="/" style={{ color: COLOR_PRIMARY_DARK }}>
  //           home page
  //         </Link>{' '}
  //         and log out first
  //       </Typography>
  //     </div>
  //   );
  // }

  return (
    <>
      <div className="resetPasswordContainer">
        <div className="center">
          <Typography
            variant="h6"
            gutterBottom
            component="h2"
            sx={{
              textAlign: 'center',
              marginBottom: passwordReseted ? 0 : 4,
              color: 'rgb(50,56,63)',
            }}
          >
            {!passwordReseted ? (
              <>
                Type your <span style={{ color: COLOR_PRIMARY_DARK }}>Email</span> below, and we'll
                notify you a link to reset your password
              </>
            ) : (
              <>Email sent!</>
            )}
          </Typography>
          {!passwordReseted && (
            <TextField
              label="Email"
              variant="outlined"
              type="email"
              value={email}
              disabled={loading}
              error={!isEmailValid}
              onChange={e => {
                setEmail(e.target.value);
                setIsEmailValid(validateEmail(e.target.value));
              }}
              sx={{
                width: '100%',
                '& input:valid + fieldset': {
                  borderColor: 'rgb(227,228,229)',
                  borderWidth: 2,
                },
                '& input:invalid + fieldset': {
                  borderColor: 'red',
                  borderWidth: 2,
                },
                '& input:valid:focus + fieldset': {
                  borderColor: 'rgb(227,228,229)',
                  borderLeftWidth: 6,
                  padding: '4px !important',
                },
              }}
              color="info"
            />
          )}
          <Button
            variant="contained"
            onClick={handlePasswordResetClick}
            disabled={loading}
            sx={{
              marginTop: 4,
              boxSizing: 'border-box',
              padding: 0,
              width: passwordReseted ? '100px !important' : '60%',
              height: passwordReseted ? '100px !important' : '50px',
              background: COLOR_PRIMARY,
              borderRadius: '100px',
              fontSize: '18px',
              '&:hover': {
                background: COLOR_PRIMARY_DARK,
              },
              ['@media (max-width:670px)']: {
                width: '100%',
                fontSize: '14px',
              },
            }}
          >
            {loading ? (
              <CircularProgress
                size={20}
                sx={{
                  color: '#fff',
                }}
              />
            ) : passwordReseted ? (
              <DoneIcon sx={{ width: '60px', height: '60px' }} />
            ) : (
              'Reset Password'
            )}
          </Button>
          {passwordReseted && (
            <Typography
              variant="body1"
              gutterBottom
              component="p"
              sx={{
                textAlign: 'center',
                marginTop: 4,
                color: 'rgb(50,56,63)',
                fontWeight: 400,
                fontSize: '18px',
              }}
            >
              Click the link in the email we sent to finish resetting your password
            </Typography>
          )}

          {passwordReseted && (
            <a href="/" style={{ textDecoration: 'none' }}>
              <Typography
                variant="body1"
                gutterBottom
                component="p"
                sx={{
                  textAlign: 'center',
                  marginTop: 4,
                  color: COLOR_PRIMARY_DARK,
                  fontWeight: 500,
                  fontSize: '20px',
                }}
              >
                Return to Login
              </Typography>
            </a>
          )}
          {alertMessage && (
            <Alert
              severity="error"
              sx={{
                width: '90%',
                marginTop: 6,
                animation: 'fadeIn 0.3s ease forwards',
              }}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setAlertMessage(null);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              <AlertTitle>Error</AlertTitle>
              {alertMessage}
            </Alert>
          )}
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
